const constants = {
    steps: ['type', 'prescription', 'brand', 'thickness', 'treatments', 'warranty'],
    stepsOptionsMap: {
        type: ['type'],
        prescription: ['prescription'],
        brand: ['brand'],
        thickness: ['thickness'],
        treatments: [
            'noTreatments',
            'polar',
            'antiReflective',
            'blueLight',
            'transition',
            'treatment',
            'colorCategory',
            'color',
        ],
    },
    logoMap: {
        'Costa Del Mar': 'LOGO01',
        'Ray-Ban_C': 'LOGO02',
        'Ray-Ban_P': 'LOGO03',
        'Ray-Ban': 'LOGO04',
        Oakley: 'LOGO05',
    },
    baseURLs: {
        genericImage: 'https://assets.lenscrafters.com/extra/image/LensCrafters/global/',
        projectImage: 'https://assets.lenscrafters.com/extra/image/rxc/images/',
        framesImage: 'https://assets.lenscrafters.com/is/image/LensCrafters',
        assetsCDN: 'https://assets.lenscrafters.com',
        learnMoreBaseEndpoint: '/wcs/resources/store/10851/espot/',
    },
    imageSrcsetTemplate: '{url}{filename}@2x.png 2x, {url}{filename}@3x.png 3x',
    imageFrameLayer:
        'https://assets.lenscrafters.com/extra/image/rxc/frames/##MODEL##__##COLOR##__RXP__FRAME__qt.png',
    imageLensNoLogoLayer:
        '?impolicy=CompositeNoLogo&Lenses=https://assets.lenscrafters.com/extra/image/rxc/lenses/##MODEL##__RXP__##CLEN##__qt.png',
    imageLensLogoLayer:
        '?impolicy=CompositeLogo&Lenses=https://assets.lenscrafters.com/extra/image/rxc/lenses/##MODEL##__RXP__##CLEN##__qt.png',
    imageLens:
        'https://assets.lenscrafters.com/extra/image/rxc/lenses/##MODEL##__RXP__##CLEN##__qt.png',
    imageLogo:
        'https://assets.lenscrafters.com/extra/image/rxc/logo/##MODEL##__RXP__##LOGO##__qt.png',
    imageLogoLayer:
        '&Logo=https://assets.lenscrafters.com/extra/image/rxc/logo/##MODEL##__RXP__##LOGO##__qt.png',
    imageLensPreview:
        'https://assets.lenscrafters.com/extra/image/rxc/lenspreview/LensPreview__RXP##CLEN##_qt.png',
    frameImages: { 
        "rayban" : {
            "default" : 'https://assets.lenscrafters.com/is/image/LensCrafters/#PARTNUMBER#__002.png?imwidth=680',
            "unbranded" : 'https://assets.lenscrafters.com/extra/image/rxc/frames/#MO#__#CO#__RXP__nologo__qt.png?imwidth=680',
            "rayban" : 'https://assets.lenscrafters.com/is/image/LensCrafters/#PARTNUMBER#__002.png?imwidth=680'
        },
        "raybanjr" : {
            "default" : 'https://assets.lenscrafters.com/is/image/LensCrafters//#PARTNUMBER#__002.png?imwidth=680',
            "unbranded" : 'https://assets.lenscrafters.com/extra/image/rxc/frames/#MO#__#CO#__RXP__nologo__qt.png?imwidth=680',
            "rayban" : 'https://assets.lenscrafters.com/is/image/LensCrafters/#PARTNUMBER#__002.png?imwidth=680'
        },
        "oakley" : {
            "default" : 'https://assets.lenscrafters.com/is/image/LensCrafters/#PARTNUMBER#__002.png?imwidth=680',
            "unbranded" : 'https://assets.lenscrafters.com/is/image/LensCrafters/#PARTNUMBER#__002.png?imwidth=680',
            "oakley" : 'https://assets.lenscrafters.com/extra/image/rxc/frames/#MO#__#CO#__RXP__logo__qt.png?imwidth=680'
        },
        "default" : {
            "default": 'https://assets.lenscrafters.com/is/image/LensCrafters/#PARTNUMBER#__002.png?imwidth=680',
            "unbranded" : 'https://assets.lenscrafters.com/is/image/LensCrafters/#PARTNUMBER#__002.png?imwidth=680'
        }
    },
    currencyFormat: {
        thousandSeparator: ',',
        decimalSeparator: '.',
        prefix: '$',
    },
    prescriptionTypes: {
        SIMPLE: 'SIMPLE',
        FULL: 'FULL',
    },
    paymentInstallments: {
        AFFIRM: 'AFFIRM',
        AFTERPAY: 'AFTERPAY',
    },
    contentNames: {
        desktopEspotBackground: 'DESK_Espot_Load',
        mobileEspotBackground: 'MOB_Espot_Load',
        desktopBrandDisclaimer: 'D_LensPanel_BrandDisclaimer',
        mobileBrandDisclaimer: 'M_LensPanel_BrandDisclaimer',
        desktopBlueDisclaimer: 'D_LensPanel_BlueDisclaimer',
        mobileBlueDisclaimer: 'M_LensPanel_BlueDisclaimer',
        blueLightAlertDeskEspotName: 'D_LensPanel_TransitionsMessage',
        blueLightAlertMobEspotName: 'M_LensPanel_TransitionsMessage',
        blueLightGamingAlertDeskEspotName: 'D_LensPanel_TransitionsMessage_Gaming',
        blueLightGamingAlertMobEspotName: 'M_LensPanel_TransitionsMessage_Gaming',
        mirrorAlertDeskContentName: 'D_LensPanel_MirrorMessage',
        mirrorAlertMobContentName: 'M_LensPanel_MirrorMessage',
        desktopPDModalEspotName: 'D_LensPanel_PupillaryDistance',
        mobilePDModalEspotName: 'D_LensPanel_PupillaryDistance',
        mobilePrescriptionModalEspotName: 'M_LensPanel_HowToReadPrescription',
        desktopPrescriptionModalEspotName: 'D_LensPanel_HowToReadPrescription',
    },
    prescriptionDefaults: {
        sphMin: -20,
        sphMax: 20,
        sphRes: 0.25,
        cylMin: -20,
        cylMax: 20,
        cylRes: 0.25,
        addMin: -5,
        addMax: 5,
        addRes: 0.25,
        pdHalfMin: 25,
        pdHalfMax: 38,
        pdHalfRes: 1,
        pdMin: 51,
        pdMax: 77,
        pdRes: 1,
    },
    promoTypes: {
        GVP: 'GVP',
    },
};

export default constants;
